import React from 'react';
import { useTranslation } from 'react-i18next';
import './VisibilityCheckbox.css';

type Props = {
    isPrivate: boolean;
    onChange: (isPrivate: boolean) => void;
    disabled?: boolean;
};

/** Chooses, once at creation, whether a questionnaire or therapy material is shared with all therapists. */
const VisibilityCheckbox = ({ isPrivate, onChange, disabled = false }: Props): JSX.Element => {
    const { t } = useTranslation();

    return (
        <label className="visibility-checkbox">
            <input
                type="checkbox"
                checked={isPrivate}
                disabled={disabled}
                onChange={(event) => onChange(event.target.checked)}
            />
            <span className="visibility-checkbox__label">{t('Only visible to me')}</span>
            <span className="visibility-checkbox__hint">
                {t('Otherwise all therapists can see, assign, edit and delete it. This cannot be changed later.')}
            </span>
        </label>
    );
};

export default VisibilityCheckbox;
